import { useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import { Button, useToast } from "../../ui";
import s from "./clientApp.module.css";
import "./clientClubPay.module.css";

export default function ClientPayMembershipButton({ membership, patientId }) {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  if (!membership || membership.status !== "pending") return null;

  const pay = async () => {
    setBusy(true);
    try {
      const data = await clinicAPI.initOnlineMembershipPayment({
        membership_id: membership.id,
        patient_id: patientId,
      });
      if (data.payment_url) {
        window.location.href = data.payment_url;
      } else {
        toast.error("Ссылка на оплату не получена");
      }
    } catch (err) {
      toast.error(err.response?.data?.error || "Онлайн-оплата недоступна");
    } finally {
      setBusy(false);
    }
  };

  const price = membership.plan?.price;
  const priceLabel =
    price != null && Number(price) > 0
      ? `${Number(price).toLocaleString("ru-RU")} ₽`
      : null;

  return (
    <div className={s.profClubPayBox}>
      <p className={s.profClubPayHint}>
        Абонемент ожидает оплаты{priceLabel ? ` · ${priceLabel}` : ""}
      </p>
      <Button type="button" size="sm" disabled={busy} onClick={pay}>
        {busy ? "…" : "Оплатить онлайн"}
      </Button>
    </div>
  );
}
